import { generateUtilityClasses } from '@mui/material';

export const dropdownMenu2Classes = generateUtilityClasses('DropdownMenu2', ['root', 'paper']);
